import React from 'react'
import { PageContextProvider } from 'vike-react/usePageContext'
import type { PageContextClient } from 'vike/types'

export function PageShell({
  pageContext,
  children,
}: {
  pageContext: PageContextClient
  children: React.ReactNode
}) {
  return (
    <PageContextProvider pageContext={pageContext}>
      {children}
    </PageContextProvider>
  )
}
